import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer } from 'react';
const AuthContext = createContext(null);
const initialState = {
    counties: [],
    isAuthenticated: false,
    refreshToken: null,
    token: null,
    user: null,
};
function reducer(state, action) {
    switch (action.type) {
        case 'LOGIN':
            return {
                ...state,
                counties: action.payload.counties,
                isAuthenticated: action.payload.isAuthenticated,
                refreshToken: action.payload.refreshToken,
                token: action.payload.token,
                user: action.payload.user,
            };
        case 'LOGOUT':
            return initialState;
        default:
            throw new Error();
    }
}
export const AuthProvider = ({ children }) => {
    const [authState, dispatch] = useReducer(reducer, initialState);
    return (_jsx(AuthContext.Provider, { value: [authState, dispatch], children: children }));
};
export const useAuth = () => {
    return useContext(AuthContext);
};
